import React from 'react';
import Link from 'next/link';
import DedicatedCardProfile from './dedicated-card-profile';

type Props = {
    modelTittle: string;
    path: any;
    alt: string;
    title: string;
    width: number;
    height: number;
    url: any;
    bg: string;
};

const DedicatedDevelopers: React.FC<Props> = ({ modelTittle, url, bg }) => {
    return (
        <div className={`card p-30 rounded-10 border dark:border-[#ffffff33] ${bg}`} data-aos="fade-up" data-aos-duration="700" data-aos-delay="300">
            <div className="card-body">
                <DedicatedCardProfile />
                <div className="mb-1 fw-700 fs-mdlg">Looking to Hire</div>
                <p className="card-title fs-lgxl fw-700 mb-[15px] text-textcolor dark:text-light">{modelTittle}</p>
                <ul className="list fs-mdlg fw-500 flex flex-col gap-2 mb-4">
                    <li>Experienced &amp; Skilled Resources</li>
                    <li>Flexible Pricing &amp; Working Models</li>
                    <li>Communication via Skype/Email/Phone</li>
                    <li>NDA and Contract Signup</li>
                    <li>On-time Delivery &amp; Post Launch Support</li>
                </ul>
                <Link href={`${url}`} className="btn btn-primary w-full block text-center">
                    Lets Talk
                </Link>
            </div>
        </div>
    );
};

export default DedicatedDevelopers;
